
export const parseDatTime = (arr) => {
    return (arr || []).map(obj => {
        if (!obj || !obj.DELIVERY_DATE) {
            return { ...obj, start: null, end: null };
        }

        let start, end;
        const [year, month, day ] = obj.DELIVERY_DATE.split('-').map(Number);
        const monthIndex = month - 1;

        if (typeof obj.DELIVERY_TIME === "string" && obj.DELIVERY_TIME.includes('-')) {
            const [startTime, endTime] = obj.DELIVERY_TIME.split('-');
            start = parseTime(year, monthIndex, day, startTime);
            end = parseTime(year, monthIndex, day, endTime);
        } else if (typeof obj.DELIVERY_TIME === "string") {
            start = parseTime(year, monthIndex, day, obj.DELIVERY_TIME);
            end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
        } else {
            start = null;
            end = null;
        }

        return { ...obj, start, end };
    });
  };

  export const parseTime = (year, month, day, time) => {
    const hours = parseInt(time.slice(0,2), 10)
    const minutes = parseInt(time.slice(2,4), 10)
    return new Date(year, month, day, hours, minutes)
  }